import { useCallback, useEffect, useRef, useState } from 'react';
import HttpService from '@picsart/rc/services/http';
import API_URL from './constants';

import { AuthProvider, TokenModel, authStatus } from '@picsart/growth-rc/AuthContext';
import { UserModel } from '@picsart/growth-rc/types';

import type AuthWrapperType from './types';

function AuthWrapper({ children }: AuthWrapperType) {
  HttpService.setConfig({
    apiUrl: API_URL
  });
  const [status, setStatus] = useState<authStatus>(authStatus.pending);
  const [user, setUser] = useState<UserModel | null>(null);
  const [tokenData, setTokenData] = useState<TokenModel>();
  const tokenDataRef = useRef<TokenModel | undefined>(tokenData);

  const [isUserFetched, setIsUserFetched] = useState(false);

  const handleTokenChange = useCallback((tknData?: TokenModel) => {
    tokenDataRef.current = tknData;
    setTokenData(tknData);
  }, []);

  useEffect(() => {
    if (isUserFetched) {
      return;
    }

    if (status === authStatus.failed || status === authStatus.resolved) {
      setIsUserFetched(true);
    }
  }, [isUserFetched, status]);

  return (
    <AuthProvider
      basePath="/"
      user={user}
      onStatusChange={setStatus}
      status={status}
      onUserChange={setUser}
      onTokenChange={handleTokenChange}
      tokenData={tokenData}
    >
      {isUserFetched ? children : null}
    </AuthProvider>
  );
}

export default AuthWrapper;
